import SaleReturnDetail from "../../components/SaleReturn/SaleReturnDetail";

const SaleReturnDetailPage = () => {
  return (
    <div>
      <SaleReturnDetail />
    </div>
  );
};

export default SaleReturnDetailPage;
